import { IntegrationType, useIntegrationsQuery } from "../../types";

export const useHasIntegration = (type: IntegrationType) => {
  const { data } = useIntegrationsQuery();

  return Boolean(data && data.integrations.includes(type));
};
